import React from 'react';
import { TextField } from '@mui/material';
import { GridColType } from '@mui/x-data-grid';
import SelectInput from '../SelectInput';
import { mapFilterTypeToInputType } from './filter-panel.util';

interface ValueInputProps {
  label: string;
  type: GridColType;
  value: any;
  setValue: (newVal: any) => void;
  variant?: 'filled' | 'outlined' | 'standard';
  fullWidth?: boolean;
}

const ValueInput: React.FC<ValueInputProps> = ({ label, type, value, setValue, fullWidth = false, variant = 'standard' }) => {
  type = mapFilterTypeToInputType(type);
  if (type == 'boolean')
    return (
      <SelectInput
        label={label}
        selected={value}
        setSelected={newVal => setValue(newVal)}
        list={[
          { label: 'True', value: 'true' },
          { label: 'False', value: 'false' },
        ]}
      />
    );
  return (
    <TextField
      variant={variant}
      label={label}
      type={type}
      InputLabelProps={{ shrink: true }}
      value={value}
      onChange={e => setValue(e.target.value)}
      fullWidth={fullWidth}
    />
  );
};

export default ValueInput;
